import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { GestionnaireGuard } from '../core/guards/gestionnaire.guard';

export const FAMILIES_ROUTES: Routes = [
  {
    path: 'families/list',
    loadComponent: () => import('../features/families/list/list.component').then(m => m.FamiliesListComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'families/add',
    loadComponent: () => import('../features/families/add/add.component').then(m => m.FamiliesAddComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
  {
    path: 'families/edit/:id',
    loadComponent: () => import('../features/families/edit/edit.component').then(m => m.FamiliesEditComponent),
    canActivate: [AuthGuard, GestionnaireGuard],
  },
];
